import {useState} from "react";
import {Box, Button, useTheme} from "@mui/material";
import {PopupModal} from "react-calendly";
import {ContactEmergency} from "@mui/icons-material";

export default function CalendyButton() {
	const theme = useTheme();

	const [isOpen, setIsOpen] = useState(false);

	return (
		<Box sx={{width: "100%"}}>
			<Button onClick={() => setIsOpen(true)}
							sx={{
								width: "100%",
								justifyContent: "left",
								color: theme.palette.text.primary,
								textTransform: "none",
								fontWeight: 500,
								fontSize: "1rem"
							}}
							startIcon={<ContactEmergency/>}>
				&nbsp;&nbsp;&nbsp;Get Demo
			</Button>
			<PopupModal
				url="https://calendly.com/junaidansari?hide_gdpr_banner=1&primary_color=ffffff"
				onModalClose={() => setIsOpen(false)}
				open={isOpen}
				/*
				 * react-calendly uses React's Portal feature (https://reactjs.org/docs/portals.html) to render the popup modal. As a result, you'll need to
				 * specify the rootElement property to ensure that the modal is inserted into the correct domNode.
				 */
				rootElement={document.getElementById("root")!}
			/>
		</Box>
	)
}
